<div class="container">
  <div
    class="icon {{ iconColor() }}"
    [class.pointer]="showSideModalIcon() && !isModal()"
    tabindex="-1"
    (mouseenter)="setHovered(true, 'icon')"
    (mouseleave)="setHovered(false, 'icon')"
    (click)="showModal($event, 'icon')"
    (keydown)="(null)"
  >
    <onyx-icon
      [name]="showSideModalIcon() ? 'side-modal-filled' : iconName()"
      [size]="16"
    ></onyx-icon>
  </div>

  <div
    class="content {{ placeholder() ? 'f-body-s' : 'f-body-m f-semibold' }}"
    [class.f-muted]="placeholder()"
  >
    <ng-content></ng-content>

    <span class="description f-body-xs">
      @if (actionLabel(); as label) {
        {{ label | translate }}
      }

      <ng-content select="[description]"></ng-content>
    </span>
  </div>
</div>

<div class="right">
  @if (issues().length) {
    <onyx-icon
      [name]="
        errors()?.length ? 'error-neutral-filled' : 'alert-two-tone-filled'
      "
      [size]="16"
      [onyxTooltip]="warningsTooltipTemplate"
    ></onyx-icon>
  }

  @if (!inactive()) {
    <onyx-icon name="arrow-triangle-down-outlined" [size]="16"></onyx-icon>
  }
</div>

<ng-template #warningsTooltipTemplate>
  <app-validation-tooltip [issues]="issues()"></app-validation-tooltip>
</ng-template>
